import { useSearchParams } from 'react-router-dom';

import { FoldableSearch } from '@web/components/FoldableSearch/FoldableSearch';

export const ConversationSearchBar = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchQuery = searchParams.get('query');
  const canCancelSearch = !!searchQuery;
  const onCancelSearch = () => {
    searchParams.delete('query');
    setSearchParams(searchParams);
  };

  return (
    <FoldableSearch
      initialValue={searchQuery}
      onSubmitSearch={(searchText) => {
        searchParams.set('query', searchText);
        setSearchParams(searchParams);
      }}
      onCancelSearch={canCancelSearch ? onCancelSearch : null}
    />
  );
};
